const $ = require("jquery");
window.jQuery = $;
window.$ = $;

require('bootstrap');
import swal from 'sweetalert2';
window.swal = swal
window.toastr = require('toastr');
require('jquery-ui');
require('./librairies/select2.full.min');
require('slick-carousel');

const Kernel = require('./utils/Kernel');
window.Kernel = new Kernel();

//App
window.Kernel.registerComponent('Header', require('./components/Header').default);
window.Kernel.registerComponent('Loader', require('./components/Loader').default);
window.Kernel.registerComponent('Sticky', require('./components/Sticky').default);
window.Kernel.registerComponent('CustomSelectVariant', require('./components/CustomSelectVariant').default);
window.Kernel.registerComponent('CustomSelect', require('./components/CustomSelect').default);
window.Kernel.registerComponent('MySpace', require('./components/MySpace').default);
window.Kernel.registerComponent('NewsletterSide', require('./components/NewsletterSide').default);
window.Kernel.registerComponent('DeleteAccount', require('./components/DeleteAccount').default);
window.Kernel.registerComponent('BackToTop', require('./components/BackToTop').default);
window.Kernel.registerComponent('PopIn', require('./components/PopIn').default);
window.Kernel.registerComponent('HomeSlider', require('./components/HomeSlider').default);
window.Kernel.registerComponent('SliderProduct', require('./components/SliderProduct').default);

//eCommerce
window.Kernel.registerComponent('Cart', require('./pages/hegyd/hegyd-ecommerce/Cart').default);
window.Kernel.registerComponent('StripeForm', require('./pages/hegyd/hegyd-ecommerce/StripeForm').default);
window.Kernel.registerComponent('AddressesSelection', require('./pages/hegyd/hegyd-ecommerce/AddressesSelection').default);
window.Kernel.registerComponent('eCommerce', require('./utils/eCommerce').default);

//Products
window.Kernel.registerComponent('ProductCard', require('./components/hegyd/hegyd-products/ProductCard').default);
window.Kernel.registerComponent('ProductCardModal', require('./components/hegyd/hegyd-products/ProductCardModal').default);
window.Kernel.registerComponent('Product', require('./pages/hegyd/hegyd-product/Product').default);
window.Kernel.registerComponent('ProductFilter', require('./components/hegyd/hegyd-products/ProductFilter').default);
window.Kernel.registerComponent('ProductImagePhotoswipe', require('./components/hegyd/hegyd-products/ProductImagePhotoswipe').default);

//Core
window.Kernel.registerComponent('Toaster', require('./components/hegyd/hegyd-core/Toaster').default);

window.addEventListener("DOMContentLoaded",() => {
    window.Kernel.mountComponents($('html'));
});

import ShopsMap from './components/ShopsMap';
customElements.define('shops-map',ShopsMap,{extends: 'div'});
